import { render, staticRenderFns } from "./AddSocialBan.vue?vue&type=template&id=b1aba5aa&"
import script from "./AddSocialBan.vue?vue&type=script&lang=js&"
export * from "./AddSocialBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports